"use client";

import { Button, Button_T, HoverCard, HoverCardProps } from "@ui/components";
import { SectionTemplate } from "./individuals/blocks";
import { Flex, Heading } from "@chakra-ui/react";
import { ButtonProp } from "lib/gcms";
import { colors } from "@areahub/theme";

export interface ClientSimpleHoverCardsSectionProps {
  title: string;
  subtitle: string;
  textColor: string;
  bg: string;
  infoCards: Omit<HoverCardProps, "label">[];
  buttons?: Omit<ButtonProp, "buttonAction" | "id">[];
}

export const ClientSimpleHoverCardsSection = (
  props: ClientSimpleHoverCardsSectionProps,
) => {
  return (
    <SectionTemplate bg={props.bg} color={props.textColor}>
      <Heading
        as={"h1"}
        fontSize={{
          base: 26,
          md: 34,
          lg: 38,
          xl: 45,
        }}
        lineHeight={1.2}
        fontWeight={"bold"}
        mb={{
          base: 8,
          lg: 12,
        }}
        textAlign={"left"}
        w={{
          lg: "80%",
        }}
      >
        {props.title}
      </Heading>
      <Heading
        as={"h2"}
        fontSize={{
          base: 16,
          md: 20,
          xl: 22,
        }}
        fontWeight={"semibold"}
        mb={{
          base: 0,
          md: 8,
          lg: 14,
        }}
        textAlign={"left"}
      >
        {props.subtitle}
      </Heading>

      <Flex
        flexDir={{
          base: "column",
          md: "row",
        }}
        gap={{
          base: 5,
          lg: 10,
        }}
        mt={8}
        w={{
          base: "80%",
          md: "full",
        }}
        mx={"auto"}
        align={"center"}
      >
        {props.infoCards.map((card, index) => (
          <HoverCard
            key={`mitigate-risks-card-${index}`}
            {...card}
            textColor={props.textColor}
          />
        ))}
      </Flex>

      <Flex
        mt={{
          base: 10,
          md: 20,
        }}
        justify={"center"}
      >
        {props.buttons?.map((btn, index) => (
          <Button
            key={`arrow-section-btn-${index}`}
            bgColor={props.textColor}
            color={props.bg}
            fontSize={{
              base: 12,
              md: 14,
              lg: 16,
              xl: 18,
            }}
            fontWeight={"bold"}
            py={{
              base: "6",
              lg: "8",
            }}
            textTransform={"uppercase"}
            {...(btn as Button_T)}
          />
        ))}
      </Flex>
    </SectionTemplate>
  );
};
